// import build_config from '../../build_config'

// export default {
//   samples: !!(build_config.production == '' && build_config.samples),
//   socketProxyUrl: `${build_config.production}/`,
//   proxyUrl: `${build_config.production}/api`,
//   proxyAppUrl: `${build_config.production}/app`,
//   backendUrl: 'http://localhost:1997/officeride/api',
//   vendorAppUrl: 'http://localhost:2022', // 'https://vendorstest.vmmaps.com/appbackend', // https://localhost:2022/
//   vendoTestAppUrl: 'http://localhost:2022',
//   vehicleApi: 'https://cors-anywhere.herokuapp.com/https://uat.apiclub.in',
//   livedrivers: 'https://api.not.nammaoorutaxi.com/cabs/ridelaterAPIrequests.php',
//   ride_request_now: 'https://api.not.nammaoorutaxi.com/cabs/dispatchrequest.php?notime=1&requestid=',
//   ridelaterrequests: 'https://api.not.nammaoorutaxi.com/cabs/ridelaterAPIrequests.php',
//   ride_request_now_selective: 'https://api.not.nammaoorutaxi.com/cabs/dispatchrequesttodriver.php',
//   ridelatersolverroutes: 'https://nammaoorutaxi.com/vrs/solver/rideshare/solve',
//   driverlists: 'https://api.not.nammaoorutaxi.com/cabs/list/driversdetails.php',
//   driverapprovedetails: 'https://api.not.nammaoorutaxi.com/cabs/manage-default.php?token=fsdfsdfsdfsdfdfs',
//   driverofficerideapprovedetails: 'https://api.not.nammaoorutaxi.com/cabs/manage-officeride.php?token=fsdfsdfsdfsdfdfs',
//   driveraccountapprovedetails: 'https://api.not.nammaoorutaxi.com/cabs/manage-account.php?token=fsdfsdfsdfsdfdfs',
//   driversbasedetails: 'https://api.not.nammaoorutaxi.com/cabs/list/fetchDrivers.php',
//   mapmatching: 'https://nammaoorutaxi.com/livetracking/api/get?id=',
//   gps_tracking_local: 'http://127.0.0.1:1253/gps-tracker/get-historical-data',
//   gps_tracking: 'https://gpstracker.nammaoorutaxi.com/gps/gps-tracker/get-historical-data',
//   gps_tracking_total: 'https://gpstracker.nammaoorutaxi.com/gps/gps-tracker/get-total-data',
//   createridelaterrequest: 'https://api.not.nammaoorutaxi.com/cabs/createridelaterrequest.php'
// }

import build_config from '../../build_config'

export default {
  samples: !!(build_config.production == '' && build_config.samples),
  socketProxyUrl: `${build_config.production}/`,
  proxyUrl: `${build_config.production}/api`,
  proxyAppUrl: `${build_config.production}/app`,
  backendUrl: 'http://localhost:1997/officeride/api',
  vendorAppUrl: 'http://localhost:2022', // https://localhost:2022/
  vendoTestAppUrl: 'http://localhost:2022',
  superAdminUrl: 'http://localhost:2022/api',
  vehicleApi: 'https://cors-anywhere.herokuapp.com/https://uat.apiclub.in',
  livedrivers: 'https://api.not.nammaoorutaxi.com/cabs/ridelaterAPIrequests.php',
  ride_request_now: 'https://api.not.nammaoorutaxi.com/cabs/dispatchrequest.php?notime=1&requestid=',
  ridelaterrequests: 'https://api.not.nammaoorutaxi.com/cabs/ridelaterAPIrequests.php',
  ride_request_now_selective: 'https://api.not.nammaoorutaxi.com/cabs/dispatchrequesttodriver.php',
  ridelatersolverroutes: 'https://nammaoorutaxi.com/vrs/solver/rideshare/solve',
  driverlists: 'https://api.not.nammaoorutaxi.com/cabs/list/driversdetails.php',
  driverapprovedetails: 'https://api.not.nammaoorutaxi.com/cabs/manage-default.php?token=fsdfsdfsdfsdfdfs',
  driverofficerideapprovedetails: 'https://api.not.nammaoorutaxi.com/cabs/manage-officeride.php?token=fsdfsdfsdfsdfdfs',
  driveraccountapprovedetails: 'https://api.not.nammaoorutaxi.com/cabs/manage-account.php?token=fsdfsdfsdfsdfdfs',
  driversbasedetails: 'https://api.not.nammaoorutaxi.com/cabs/list/fetchDrivers.php',
  mapmatching: 'https://nammaoorutaxi.com/livetracking/api/get?id=',
  gps_tracking_local: 'http://127.0.0.1:1253/gps-tracker/get-historical-data',
  gps_tracking: 'https://gpstracker.nammaoorutaxi.com/gps/gps-tracker/get-historical-data',
  gps_tracking_total: 'https://gpstracker.nammaoorutaxi.com/gps/gps-tracker/get-total-data',
  createridelaterrequest: 'https://api.not.nammaoorutaxi.com/cabs/createridelaterrequest.php'
}
